import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';

export interface ToastMessage {
  id: string;
  type: 'success' | 'danger' | 'warning' | 'info' | 'default';
  title: string;
  message: string;
  duration?: number;
}

@Component({
  selector: 'app-custom-toast',
  templateUrl: './custom-toast.component.html',
  styleUrls: ['./custom-toast.component.scss'],
  animations: [
    trigger('toastAnimation', [
      state('void', style({
        transform: 'translateY(-100%)',
        opacity: 0
      })),
      state('visible', style({
        transform: 'translateY(0)',
        opacity: 1
      })),
      transition('void => visible', animate('300ms ease-out')),
      transition('visible => void', animate('300ms ease-in'))
    ])
  ]
})
export class CustomToastComponent implements OnInit, OnDestroy {
  @Input() toast: ToastMessage;
  @Output() close = new EventEmitter<string>();

  private timeoutId: any;

  ngOnInit() {
    if (this.toast.duration && this.toast.duration > 0) {
      this.timeoutId = setTimeout(() => {
        this.closeToast();
      }, this.toast.duration);
    }
  }

  ngOnDestroy() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  closeToast() {
    this.close.emit(this.toast.id);
  }

  getIconClass(): string {
    switch (this.toast.type) {
      case 'success':
        return 'ni ni-check-bold';
      case 'danger':
        return 'ni ni-fat-remove';
      case 'warning':
        return 'ni ni-notification-70';
      case 'info':
        return 'ni ni-bell-55';
      default:
        return 'ni ni-bell-55';
    }
  }
}
